module.exports = __webpack_public_path__ + "img/skip.bfcc6e7e.png";